//
//

import { addWindowResizeCallback } from "@/assets/js/appResize";
import { mapActions, mapGetters, mapMutations } from "vuex";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQEmptyState from "@/components/Generics/AQEmptyState/AQEmptyState.vue";

export default {
    components: {
        AQEmptyState,
        AQButton
    },
    data() {
        return {
            isSmallScreen: false,
            accessibilityEnabled: false,
            signUpAppId: "",
            maintenance: false,
            maintenanceLoginActive: false,
            wrongTenant: false
        };
    },
    computed: {
        ...mapGetters("main", ["getInfoApp"]),
        year() {
            return new Date().getFullYear();
        },
        isMobileAndMaintenance() {
            return this.isSmallScreen && this.maintenance;
        }
    },
    created() {
        this.$root.$on("invalidTenantCheck", () => {
            this.wrongTenant = true;
        });
        setTimeout(() => {
            const wrongTenant = JSON.parse(localStorage.getItem("wrongTenantActive"));
            if (!this.wrongTenant && !wrongTenant) {
                this.actBrandName().then((data) => {
                    document.title = data.companyName;
                });
            }
        }, 500);
    },
    mounted() {
        setTimeout(() => {
            const wrongTenant = JSON.parse(localStorage.getItem("wrongTenantActive"));
            if (this.$store && !wrongTenant && !this.wrongTenant) {
                this.getMultiFeaturesOption().then(data => {
                    const signUpObj = data.data.find(item => item.code === "SIGNUP");
                    if (signUpObj.enabled && signUpObj.extraData) {
                        localStorage.setItem("registerAppId", signUpObj.extraData.processDefinitionId || signUpObj.extraData.applicationId);
                        this.signUpAppId = signUpObj.extraData.processDefinitionId || signUpObj.extraData.applicationId;
                    } else {
                        this.signUpAppId = "";
                    }
                    const accessibilityObj = data.data.find(item => item.code === "ACCESSIBILITY");
                    this.accessibilityEnabled = accessibilityObj.enabled;
                });
            }
        }, 800);
        this.$root.$on("backToMaintenance", () => {
            this.maintenanceLoginActive = false;
        });
        this.$root.$on("maintenanceLogin", () => {
            localStorage.removeItem("isLogout");
            this.maintenanceLoginActive = true;
        });
    },
    beforeUpdate() {
        this.maintenance = JSON.parse(localStorage.getItem("maintenanceStarted"));
        addWindowResizeCallback({ fn: this.checkWindowSize, ctx: this }, true);
    },
    beforeDestroy() {
        this.$root.$off("invalidTenantCheck");
    },
    methods: {
        ...mapActions("main", ["getMultiFeaturesOption", "actBrandName"]),
        ...mapMutations("components", ["setIsSmallScreen"]),
        checkWindowSize(size = window.innerWidth) {
            this.isSmallScreen = size < this.$q.screen.sizes.sm;
            this.setIsSmallScreen(this.isSmallScreen);
        },
        refreshPage() {
            window.location.reload();
        },
        maintenanceLogin() {
            localStorage.removeItem("isLogout");
            this.maintenanceLoginActive = true;
            this.$router.push("/maintenance/login");
        }
    }
};
